import { CartLinesUpdateEvent } from '@shopify/events';
import { morphSection } from '@theme/section-renderer';
import { fetchConfig } from '@theme/utilities';

function collectSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) {
      ids.add(el.dataset.sectionId);
    }
  });
  return Array.from(ids);
}

async function addBundleDuo02(root) {
  const p2Id = root.dataset.p2Variant;
  const p3Id = root.dataset.p3Variant;
  if (!p2Id || !p3Id) return;

  const button = root.querySelector('[data-bundle-duo02-add]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  button.disabled = true;
  const originalLabel = button.textContent;
  button.textContent = 'Ajout en cours…';

  const sectionIds = collectSectionIds();
  const body = JSON.stringify({
    items: [
      { id: Number(p2Id), quantity: 1 },
      { id: Number(p3Id), quantity: 1 },
    ],
    sections: sectionIds.join(','),
    sections_url: window.location.pathname,
  });

  const deferredPromise = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'bundle-duo02',
      lines: [
        { merchandiseId: p2Id, quantity: 1 },
        { merchandiseId: p3Id, quantity: 1 },
      ],
      promise: deferredPromise.promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', fetchConfig('json', { body }));
    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Échec ajout au panier');
    }

    if (data.sections && sectionIds.length) {
      sectionIds.forEach((sectionId) => {
        if (data.sections[sectionId]) {
          const isDrawer = sectionId.includes('cart-drawer');
          morphSection(sectionId, data.sections[sectionId], {
            mode: isDrawer ? 'hydration' : 'full',
          });
        }
      });
    }

    deferredPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
      detail: {
        sections: data.sections,
        items: data.items,
        source: 'canicule-bundle-duo02',
        didError: false,
      },
    });

    button.textContent = 'Ajouté au panier';
    window.setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 1800);
  } catch (error) {
    deferredPromise.reject(error);
    button.textContent = 'Réessayer';
    button.disabled = false;
    console.warn('[canicule-bundle-duo02]', error);
  }
}

function initRoot(root) {
  if (root._caniculeBundleInit) return;
  root._caniculeBundleInit = true;

  const button = root.querySelector('[data-bundle-duo02-add]');
  if (!button) return;

  button.addEventListener('click', () => addBundleDuo02(root));
}

function init(scope) {
  (scope || document).querySelectorAll('[data-canicule-bundle-duo02]').forEach(initRoot);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(document));
} else {
  init(document);
}

document.addEventListener('shopify:section:load', (event) => {
  init(event.target);
});
